import { ChangeDetectorRef, Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ControlQuestion } from 'src/app/models/controlQuestion.model';
import { ControlQuestionAnswers } from 'src/app/models/controlQuestionAnswers.model';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { ControlCorrectComponent } from '../control-correct/control-correct.component';
import { ControlFalseComponent } from '../control-false/control-false.component';

@Component({
    selector: 'app-control-question',
    templateUrl: './control-question.component.html',
    styleUrls: ['./control-question.component.scss'],
    standalone: false
})
export class ControlQuestionComponent implements OnInit {
  labels;
  labelsSub: Subscription;

  adminLabels;
  adminLabelsSub: Subscription;

  flg: boolean = false;
  isClicked: boolean = false;
  questions: ControlQuestion[] = []
  currentQuestion: ControlQuestion
  showControl: boolean = true
  correctAnswer: boolean = false
  falseAnswer: boolean = false
  player

  answers = []
  constructor(public dialog: MatDialog, private adminLanguageService: AdminLanguageService, private languageService: UserLanguageService, public dialogRefThis: MatDialogRef<ControlQuestionComponent>,
     @Inject(MAT_DIALOG_DATA) public data,
     private cd: ChangeDetectorRef,
     private ngZone: NgZone)
  {
    this.questions = this.data.controlQuestions;
    this.currentQuestion = this.questions[0];
    this.player = this.data.player;
    console.log('haha', this.questions);
  }

  ngOnInit(): void {
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })

    this.adminLabelsSub = this.adminLanguageService.labels$.subscribe((adminLabels) => {
      this.adminLabels = adminLabels;
    })
    this.sortAnswers()
  }

  sortAnswers() {
    this.questions.forEach((question) => {
      if(!question.random) {
        question.answers.sort((a, b) => {
          return a.order - b.order;
        });
      } else {
        question.answers.sort((a, b) => {
          return Math.random() - 0.5
        });
      }
    });
  }

  onSelect(question: ControlQuestion, answer: ControlQuestionAnswers) {
    this.isClicked = true;
    if (question.type == 1) {
      question.answers.forEach((x) => { if (x._id !== answer._id) x.selected = false; })
    }
    else {
      question.answers.forEach((x) => {
        if (x._id == answer._id) {
          if (x.selected) {
            x.selected = false
            x.selected = true
          }
          else {
            x.selected = true
            x.selected = false
          }
        }
      })
    }
  }

  nextQuestion(): ControlQuestion | boolean {
    let index = this.questions.indexOf(this.currentQuestion);
    if (index < this.questions.length - 1) {
      return this.currentQuestion = this.questions[index + 1];
    }
    else {
      this.dialogRefThis.close();

      return false;
    }
  }

  submit(question: ControlQuestion) {
    this.nextQuestion();
    this.cd.detectChanges();
    this.showControl = false;
      if (question.type == 1) {
        question.answers.forEach((x) => {
          if (x.selected) {
            if (x.correct == true) {
              this.showControl = false;
              this.correctAnswer = true;
              //this.dialogRef.close({correct: "correct", answers: []});
              const dialogRef1 = this.dialog.open(ControlCorrectComponent, {
                backdropClass: "blurBackground2",
                disableClose: true,
                width: '300px',
              });
              dialogRef1.afterClosed().subscribe((result) => {
                this.player.nativeElement.play()
               })
            } else {
              this.showControl = false;
              this.falseAnswer = true;
              let correctAns = []
              question.answers.forEach((t) => {
                if (t.correct) {
                  correctAns.push(t.textAns1)
                  //this.dialogRef.close({correct: "false", answers: correctAns});
                  const dialogRef2 = this.dialog.open(ControlFalseComponent, {
                    disableClose: true,
                    width: '300px',
                    data: {
                      text: correctAns,
                      mandatory: question.mandatory
                    }
                  });
                   dialogRef2.afterClosed().subscribe((result) => {
                      if(question.mandatory) {
                        this.player.nativeElement.currentTime = 0;
                      }

                   })
                }
              })
              this.answers = correctAns;
            }
          }
        })
      } else {
        for (let index = 0; index < question.answers.length; index++) {
          const element = question.answers[index];
          if (element.correct) {
            if (element.selected == true) {
              this.flg = false;
            } else {
              this.flg = true;
              break;
            }
          }
          if (element.correct == false) {
            if (element.selected == true) {
              this.flg = true;
              break;
            }
          }

        }
        if (this.flg == false) {
          this.showControl = false;
          this.correctAnswer = true;
          //this.dialogRef.close({correct: "correct", answers: []});
          const dialogRef3 = this.dialog.open(ControlCorrectComponent, {
            disableClose: true,
            width: '300px',
          });
          // dialogRef3.afterClosed().subscribe((result) => {
          //   this.dialogRef1.close()
          // })
        } else {
          this.showControl = false;
          this.falseAnswer = true;
          let correctAnswers = []
          question.answers.forEach((t) => {
            if (t.correct) {
              correctAnswers.push(t.textAns1)
              //this.dialogRef.close({correct: "false", answers: correctAnswers});

              const dialogRef4 = this.dialog.open(ControlFalseComponent, {
                disableClose: true,
                width: '300px',
                data: {
                  text: correctAnswers
                }
              });
              // dialogRef4.afterClosed().subscribe((result) => {
              //   this.dialogRef1.close()
              // })
            }
          })
          this.answers = correctAnswers
        }
      }

    question.answers.forEach((x) => {
        if (x.selected) {
          x.selected = false
        }
    })

    this.dialogRefThis.close(!this.currentQuestion.mandatory || this.correctAnswer)
  }

  // submit(question: ControlQuestion) {
  //     this.dialogRef1.close(true);
  // }

  onNoClick(){
    this.dialogRefThis.close(this.correctAnswer)
  }

}
